import {Campaign} from '../../../../types/src';

export function isCampaignRetention(campaign: Campaign) {
  return campaign && campaign.type && campaign.type.includes('retention');
}
